module.exports = __webpack_public_path__ + "img/skull2.56017483.png";